import { createSlice } from '@reduxjs/toolkit'
const img1 = "/assets/images/clients/passport.jpg";
const img2 = "/assets/images/clients/agent.png";

const clientSlice = createSlice({
    name: 'clients',
    initialState: {
      payload: [
        {
          img: img2,
          name: 'Dr. Usman Abubakar',
          remark: 'ABAAFASHAB provides premium services like no other. We are glad to have our records sets straight again. Regards.',
          position: 'Chief Executive Officer.',
          company: 'WeBank L.T.D'
        },
        {
          img: img1,
          name: 'CLIENT NAME ',
          remark: 'ABAAFASHAB provides premium services like no other. We are glad to have our records sets straight again. Regards.',
          position: 'Chief Executive Officer',
          company: 'UX ELITE TECHNOLOGIES'
        },
        {
            img: img2,
            name: 'Hon. CLIENT NAME',
            remark: 'ABAAFASHAB provides premium services like no other. We are glad to have our records sets straight again. Regards.',
            position: 'Member Bida South',
            company: 'State Government House'
          },
          {
            img: img2,
            name: 'Dr. Client Name',
            remark: 'ABAAFASHAB provides premium services like no other. We are glad to have our records sets straight again. Regards.',
            position: 'CEO',
            company: 'First Bank of Nigeria'
          },
          {
            img: img2,
            name: 'Mr. ',
            remark: 'ABAAFASHAB provides premium services like no other. We are glad to have our records sets straight again. Regards.',
            position: 'Client Position',
            company: 'Company/Organization Name'
          },
          {
            img: img2,
            name: 'Client Name',
            remark: 'ABAAFASHAB provides premium services like no other. We are glad to have our records sets straight again. Regards.',
            position: 'CEO',
            company: 'ACCESS BANK NIG.'
          },
      ]
    }
    ,
    reducers: {
        clients: (state, action) => {
            state.sliders = action.payload;
        }
    }
})

export const {clients} = clientSlice.actions;
export default clientSlice.reducer;
